import { ILoadOptions, Player } from 'mggp-player';
import { PlayingEntity } from '../PlayingEntity';
import { PlayerState, PLAYER_PROPERTY } from '../types';

export type PlayVideoFunc = (playingEntity: PlayingEntity) => void;

export function getPlayVideoFunc(player: Player): PlayVideoFunc {
  return (playingEntity) => {
    if (!playingEntity.isCatchup) {
      player.set(PLAYER_PROPERTY.wssIgnoreStopEvent, true);
      player.set(PLAYER_PROPERTY.wssIgnoreVideoInfoEvent, true);
    } else {
      player.set(PLAYER_PROPERTY.wssIgnoreStopEvent, false);
      player.set(PLAYER_PROPERTY.wssIgnoreVideoInfoEvent, false);
    }
    if (playingEntity.isVideoElementSeek) {
      const targetTimestamp =
        player.get(PLAYER_PROPERTY.currentTimestamp) - playingEntity.timeOffset;
      const video = player.getPlayableElement();
      if (video) {
        video.currentTime = targetTimestamp;
      }
      playingEntity.resetIsVideoElementSeek();
    } else {
      const playerState = player.get(PLAYER_PROPERTY.state);
      const options: ILoadOptions = {
        ...player.config.checkDefaultOptions(playingEntity.videoInfo),
        autoplay:
          playingEntity.isForceAutoplay ||
          playerState !== PlayerState.paused ||
          playerState === PlayerState.unknownDich,
      };
      if (playingEntity.startSeconds) {
        options.startSeconds = playingEntity.startSeconds;
      }
      playingEntity.resetForceAutoplay();

      player.stop();
      setTimeout(() => {
        player.load(playingEntity.src, playingEntity.videoInfo, options);
      }, 0);
    }
  };
}
